import { useQuery } from "@apollo/client";
import { MigrationShowQuery } from "../graphql/queries";

/**
 * Хук для загрузки данных миграции по ID
 */
export function useMigrationShowQuery(id?: string | null, skip = false) {
  return useQuery(MigrationShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
